export default "__VITE_ASSET__CplQg0RP__"